import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLayoutModule, CommonUIBasicModule, CommonUIButtonsModule, CommonUIElementsModule, CommonUIFieldsModule, PictureScannerModule, TranslationComponentsModule } from '@sdbn/common';
import { TaskExecutionComponent } from './task-execution/task-execution.component';
import { MatRippleModule } from '@angular/material/core';
import { PictureSeriesTaskDialogComponent } from './picture-series-task-dialog/picture-series-task-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentModule } from '@sdbn/tmc-legacy';



@NgModule({
  declarations: [
    TaskExecutionComponent,
    PictureSeriesTaskDialogComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIBasicModule,
    CommonUIElementsModule,
    CommonUIButtonsModule,
    CommonUIFieldsModule,
    MatRippleModule,
    TranslationComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    PictureScannerModule,
    DocumentModule
],
  exports: [
    TaskExecutionComponent
  ]
})
export class TasksModule { }
